export const items = [
  {
    'id': 1,
    'name': 'Hoodie - L',
    'price': 149000,
    'image': 'assets/hoodie_image.jpg',
    'quantity': 1
  },
  {
    'id': 2,
    'name': 'Hoodie - S',
    'price': 99000,
    'image': 'assets/hoodie_image.jpg',
    'quantity': 1
  }
];
